export const formatPrice = (amount = 0, removeDecimals = false) => {
  const currencyFormatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: removeDecimals ? 0 : 2,
  });

  return currencyFormatter.format(parseFloat(amount));
};
